import { APP_NAME } from "domain/core/app/configuration";

const key = `${APP_NAME || `IgnitePlatform:${process.env.NODE_ENV}`}`;

export const PERSIST_KEY = key.replace(/\s/, "_");
